// extracted by mini-css-extract-plugin
export default {"container":"_1ZECbBEVToLV6jWi7EjXJI","withFooter":"_3kzFfUI4gsTp3H6YQuYhjF"};